import styled from 'styled-components'

import { theme } from '@/styles/theme'

export const ChartAnnotation = styled.div`
  font-size: 12px;
  color: ${theme.colors.textSecond};
  line-height: 1.9;

  @media screen and (max-width: 1047px) {
    font-size: 11px;
  }
`
